import { Image } from "@chakra-ui/react"
import { toJDSvgUrl } from "utils/avatar";

const HashBasedAvatar = ({ UID, size }: { UID: string, size: number }) => (
    <Image src={toJDSvgUrl(UID, size)} />
);

export default HashBasedAvatar;
